<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<ion-content
  *ngIf="!showRetry && !loading"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div
    class="content-list content-scroll"
    [ngClass]="{ 'content-list--with-button': selectedItem }"
  >
    <app-ion-common-label
      [id]="idLabelOriginIncome"
      labelStyle="display-rg"
      labelDescription="Qual a origem da sua renda ou ocupação?"
      label="Estes dados são uma exigência dos órgãos reguladores, necessários para o seu cadastro e protegidos por sigilo bancário."
    >
    </app-ion-common-label>

    <div class="conent-center">
      <app-ion-common-radio
        [id]="idRadioOriginIncome"
        [ariaLabel]="textAria"
        [itens]="originIncome"
        [selectedValue]="selectedItem"
        [disabled]="!this.edit"
        (changeRadio)="changeItem((selectedItem = $event))"
        (valueNameRadio)="selectedName = $event"
        (valueAdditionalFields)="fieldsRequireds = $event"
      ></app-ion-common-radio>
    </div>
  </div>

  <app-ion-common-button
    [id]="idButtonOriginIncome"
    class="hidden"
    [ngClass]="{ hidden: !buttonEnable || !selectedItem }"
    [attr.aria-hidden]="!buttonEnable || !selectedItem"
    label="Continuar"
    (clickButton)="clickNext()"
  ></app-ion-common-button>
</ion-content>

<ion-content *ngIf="showRetry">
  <app-ion-common-retry
    [headerId]="headerId"
    (sendEventRetry)="getOriginIncome()"
  >
  </app-ion-common-retry>
</ion-content>
